import React from 'react';

// Ítem de "Preguntas frecuentes" con el lenguaje visual de marca:
// tarjeta clara con barra de acento lateral (verde→azul) e ícono de pregunta verde.
const FaqItem = ({ q, a }) => (
    <div
        className="group relative overflow-hidden rounded-2xl bg-white border border-slate-200/80 shadow-sm p-6 pl-7 transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5 hover:border-salient-green/50"
        data-aos="fade-up"
    >
        <span className="absolute left-0 top-0 h-full w-1.5 bg-gradient-to-b from-salient-green to-salient-primary"></span>
        <h3 className="font-heading font-bold text-salient-primary mb-2 flex items-start gap-3">
            <i className="fas fa-circle-question text-salient-green mt-0.5"></i>
            <span>{q}</span>
        </h3>
        <p className="text-slate-600 leading-relaxed pl-8">{a}</p>
    </div>
);

export default FaqItem;
